<div class="chart-container" #chartContainer>
  <apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [xaxis]="chartOptions.xaxis"
    [dataLabels]="chartOptions.dataLabels"
    [stroke]="chartOptions.stroke"
    [yaxis]="chartOptions.yaxis"
    [legend]="chartOptions.legend"
    [grid]="chartOptions.grid"
    [tooltip]="chartOptions.tooltip"
    [colors]="chartOptions.colors"
    [plotOptions]="chartOptions.plotOptions"
    [labels]="chartOptions.labels ?? []">
  </apx-chart>
</div>